import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DtpContentContainer,
} from 'dtp-react-components';
import {
  Button,
} from '../../../components/index';
import {
  trataMensagensErro,
  trataMensagemSucesso,
  doGet,
  doPut,
  doPost,
  validateObject,
} from '../../../utils/requests';

import DadosCronogramaPagamento from './DadosCronogramaPagamento';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';

class CronogramaPagamento extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    cronogramaPagamento: {
      ano: null,
      mes: null,
      dataCND: null,
      dataObitos: null,
      dataFechamentoPrevia: null,
      dataConsultaPrevia: null,
      dataFechamentoFolha: null,
      dataRelatoriosBG: null,
      dataEnvioBB: null,
      dataPrazoDefesa: null,
      dataPrazoAnalise: null,
      dataPrazoPagamento: null,
      competencia: null,
      habilitarBotao: null,
    },
    cronogramaPagamentoPesquisa: {
      ano: null,
      mes: null,
    },
    touched: false,
    validadeCampos: {
      dataCND: false,
      dataObitos: false,
      dataFechamentoPrevia: false,
      dataConsultaPrevia: false,
      dataFechamentoFolha: false,
      dataRelatoriosBG: false,
      dataEnvioBB: false,
      dataPrazoDefesa: null,
      dataPrazoAnalise: null,
      dataPrazoPagamento: false,
      competencia: true,
    },
    bloqueio: {
      competencia: true,
    },
    acao: 'novo',
    showNoContent: true,
    noContentPrimaryMessage: 'Cronograma de pagamento não encontrado para o participante informado.',
    noContentSecondaryMessage: 'Informe um cronograma válido.',
    chaveConfirmacao: null,
  });

  componentDidMount() {
    this.montaFormulario();
  }

  montaValidadeCampos = (cronogramaPagamento) => {
    const { validadeCampos } = { ...this.state };
    Object.keys(cronogramaPagamento).forEach((key) => {
      validadeCampos[key] = true;
    });
    return validadeCampos;
  }

  montaFormulario = () => {
    this.setState({
      acao: this.props.match.params.acao,
      cronogramaPagamento: {
        ano: this.props.match.params.ano,
        mes: this.props.match.params.mes,
      },
    });

    if (this.props.match.params.acao === 'novo') {
      this.setState({
        cronogramaPagamento: {
          ano: this.props.match.params.ano,
          mes: this.props.match.params.mes,
          competencia: this.formatarCompetencia(this.props.match.params.mes, this.props.match.params.ano),
        },
        validadeCampos: {
          ...this.state.validadeCampos,
        },
      });
    } else {
      this.setState({
        acao: this.props.match.params.acao,
        validadeCampos: {
          ...this.state.validadeCampos,
        },
      }, this.buscaCronogramaPagamento);
    }
  }

  trataSucessoResponsePesquisa = (response) => {
    this.setState({
      bloqueio: {
        ...response.data,
      },
      requestPesquisa: null,
    });
  }

  handleSuccessBuscaCronograma = (response) => {
    const { acao } = { ...this.state };
    if (response.data) {
      if (acao === 'alterar') {
        const validadeCampos = this.montaValidadeCampos(response.data);
        this.setState({ validadeCampos });
      }
      this.setState({
        cronogramaPagamento: { ...this.state.cronogramaPagamento, ...response.data },
      });
    }
  }

  buscaCronogramaPagamento = () => {
    const { cronogramaPagamentoPesquisa } = { ...this.state };
    const url = 'cronogramas-pagamento';
    cronogramaPagamentoPesquisa.mes = this.props.match.params.mes;
    cronogramaPagamentoPesquisa.ano = this.props.match.params.ano;

    doGet(
      url,
      this.handleSuccessBuscaCronograma,
      this.handleErrorBuscaCronograma,
      {
        ...this.state.cronogramaPagamentoPesquisa,
      },
    );
  }

  handleErrorBuscaCronograma = (error) => {
    if (error) {
      if (error.status) {
        this.setState({
          showNoContent: true,
        });
      }
    }
  }

  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.state };
    if (acao === 'novo' || acao === 'alterar') {
      return validateObject(this.state.validadeCampos);
    }
    return false;
  }

  handleChange = (changeObj, name) => {
    const { cronogramaPagamento } = { ...this.state };
    this.setState({
      [name]: changeObj.value,
      cronogramaPagamento: {
        ...cronogramaPagamento,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    });
  }

  handleSaveButton = () => {
    this.confirmSendData();
  }

  /**
   * Trata envio dos dados
   */
  confirmSendData = () => {
    const touched = true;
    const url = 'cronogramas-pagamento';
    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });

    this.setState({
      touched,
      validadeCampos,
    }, () => this.handleSave(url));
  }

  /**
   * Trata as acoes dos botao Salvar
   */
  handleSave = (url) => {
    if (this.formularioProntoParaEnvio()) {
      const { acao } = { ...this.state };
      const { cronogramaPagamento } = { ...this.state };

      const competenciaPrimeiraParte =
      cronogramaPagamento.competencia.substring(0, cronogramaPagamento.competencia.indexOf('/'));
      const competenciaSegundaParte =
      cronogramaPagamento.competencia.substring(cronogramaPagamento.competencia.indexOf('/') + 1, cronogramaPagamento.competencia.toString().length);
      if (competenciaPrimeiraParte) {
        cronogramaPagamento.mes = Number(competenciaPrimeiraParte);
      }
      if (competenciaSegundaParte) {
        cronogramaPagamento.ano = Number(competenciaSegundaParte);
      }
      if (acao === 'novo') {
        doPost(
          url,
          cronogramaPagamento,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
        );
      } else {
        doPut(
          url,
          cronogramaPagamento,
          this.trataSucessoResponseEnvio,
          this.trataErrosResponse,
        );
      }
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = () => {
    this.trataSucesso();
    this.props.history.goBack();
  }

  trataSucesso = () => {
    let mensagemConfirmacao = '';
    if (this.state.acao === 'novo') {
      mensagemConfirmacao = 'Cronograma criado';
    } else {
      mensagemConfirmacao = 'Cronograma alterado';
    }
    trataMensagemSucesso([mensagemConfirmacao]);
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      const { data } = { ...error };
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
      });
    }
  }

  trataBotaoVoltar = () => {
    this.props.history.goBack();
  }

  formularioCronograma = () => (
    <DadosCronogramaPagamento
      acao={this.state.acao}
      auth={this.props.auth}
      estadoFormulario={this.state}
      handleChange={this.handleChange}
      handleChangeComboNome={this.handleChangeComboNome}
      match={this.props.match}
    />
  );

  formatarCompetencia = (mes, ano) => {
    let objCompetencia = `${null}/${null}`;
    if (mes !== '0' && ano !== '0') {
      objCompetencia = `${mes}/${ano}`;
      if (objCompetencia.length !== 7) {
        objCompetencia = `0${objCompetencia}`;
      }
    }
    return objCompetencia;
  };

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  render() {
    const botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.history.goBack}
        // onClick={this.props.history.push('/consultaBloqueio/bloqueio')}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    const botaoAcaoPrincipal = (
      <ProtectedItem allowedPermissions={['analisar-negocio-sprev']}>
        <Button
          className="dtp-primary right"
          disabled={!this.formularioProntoParaEnvio()}
          title="Salvar"
          onClick={this.handleSaveButton}
          hint="Salvar"
        />
      </ProtectedItem>
    );

    const retorno = (
      <DtpContentContainer>
        {this.formularioCronograma()}
        <div className="row">
          { botaoAcaoVoltar }
          {this.state.acao !== 'detalhar' ? botaoAcaoPrincipal : ''}
        </div>
      </DtpContentContainer>
    );
    return retorno;
  }
}

CronogramaPagamento.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      mes: PropTypes.string,
      ano: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
}.isRequired;

CronogramaPagamento.defaultProps = {
  match: null,
  auth: null,
  destinatarios: [],
};

export default CronogramaPagamento;




// WEBPACK FOOTER //
// ./src/pages/cadastros/cronograma-pagamentos/CronogramaPagamento.jsx